module.exports = __webpack_public_path__ + "static/img/icon1.17d55352.svg";